import React from 'react';
import { Filter, Sparkles, Package, FileCheck } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
export function QualityStandards() {
  const {
    t
  } = useLanguage();
  const standards = [{
    icon: Filter,
    title: t.qualityStandards.standards.sorting.title,
    description: t.qualityStandards.standards.sorting.description
  }, {
    icon: Sparkles,
    title: t.qualityStandards.standards.hygiene.title,
    description: t.qualityStandards.standards.hygiene.description
  }, {
    icon: Package,
    title: t.qualityStandards.standards.packaging.title,
    description: t.qualityStandards.standards.packaging.description
  }, {
    icon: FileCheck,
    title: t.qualityStandards.standards.compliance.title,
    description: t.qualityStandards.standards.compliance.description
  }];
  return <section id="quality" className="w-full py-16 md:py-24 bg-gray-50" data-id="element-229">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-230">
        {/* Section Header */}
        <div className="text-center mb-12" data-id="element-231">
          <span className="inline-block px-4 py-1.5 bg-emerald-100 text-emerald-700 rounded-full text-sm font-semibold mb-4" data-id="element-232">
            {t.qualityStandards.badge}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-233">
            {t.qualityStandards.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-234">
            {t.qualityStandards.subtitle}
          </p>
        </div>

        {/* Standards Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-235">
          {standards.map((standard, index) => <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow border border-gray-100 text-center" data-id="element-236">
              <div className="w-16 h-16 bg-emerald-100 rounded-2xl flex items-center justify-center mx-auto mb-5" data-id="element-237">
                <standard.icon className="w-8 h-8 text-emerald-700" data-id="element-238" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-239">
                {standard.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-240">
                {standard.description}
              </p>
            </div>)}
        </div>

        {/* Compliance Statement */}
        <div className="bg-emerald-700 rounded-2xl p-8 md:p-10 text-center" data-id="element-241">
          <p className="text-white text-lg md:text-xl max-w-3xl mx-auto leading-relaxed" data-id="element-242">
            {t.qualityStandards.statement}
          </p>
        </div>
      </div>
    </section>;
}